export default __webpack_public_path__ + "static/media/bin_red.cfb57648.svg";